import { CSSProperties, useState } from 'react';
import useOrganization from 'Hooks/useOrganization';
import TeamMemberList from '../componentsOrganization/TeamMemberList/TeamMemberList';
import AddMemberModal from '../componentsOrganization/AddMemberModal/AddMemberModal';
import OrganizationTabSection from '../OrganizationTabSection';
import { TEAM_PLAN_ADDITIONAL_SEAT_PRICE, TEAM_PLAN_INCLUDED_SEATS } from 'modules/Const'
import DebugBox from 'components/shareable/DebugBox';
import Colors from "modules/Colors";
import ButtonSymphony from 'elements/ButtonSymphony';
import { Body2, Caption } from 'components/shareable/Typography';

const OrganizationTabTeam = () => {
  const { teamMembers, getSelectedTeamMember } = useOrganization();
  const selectedTeamMember = getSelectedTeamMember();

  const [searchTerm, setSearchTerm] = useState<string>();
  const [isMemberModalOpen, setIsMemberModalOpen] = useState<boolean>(false);

  const renderEmptyIcon = () => {
    return (
      <div className='emptyIconContainer' style={sty.emptyIconContainer}>
        <div className='emptyIconCenter' style={sty.emptyIconCenter} />
      </div>
    );
  };

  const renderTeamTabFooter = () => {
    return (
      <div className='teamTabFooterContainer' style={sty.teamTabFooterContainer}>
        <div className="flex gap-4 items-center">
          {renderEmptyIcon()}
          <div className="flex flex-col gap-1">
            <Body2 color={Colors.greyDark}>
              You have {TEAM_PLAN_INCLUDED_SEATS - teamMembers.length} user seats available
            </Body2>
            <Caption color={Colors.greyDark}>
              {TEAM_PLAN_INCLUDED_SEATS} seats are included with the team plan, +${TEAM_PLAN_ADDITIONAL_SEAT_PRICE} / month for additional
            </Caption>
          </div>
        </div>
        <ButtonSymphony
          className="buttonAddMemberAvailableSeatBadge"
          onClick={() => setIsMemberModalOpen(true)}
          variant="text"
        >
          Add member
        </ButtonSymphony>
      </div>
    )
  }

  return (
    <>
      <OrganizationTabSection
        className="OrganizationTeamTab"
        buttonClassName="organizationPageAddTeamMemberButton"
        title="Team"
        searchValue={searchTerm}
        onSearch={setSearchTerm}
        buttonText="Add Team Member"
        onButtonClick={() => setIsMemberModalOpen(true)}
        showDividers
      >
        <TeamMemberList
          searchTerm={searchTerm}
        />
        {teamMembers.length < TEAM_PLAN_INCLUDED_SEATS &&
          renderTeamTabFooter()
        }
      </OrganizationTabSection>

      <AddMemberModal
        isOpen={isMemberModalOpen}
        onClose={() => setIsMemberModalOpen(false)}
      />
    </>
  );
};

const sty: Record<string, CSSProperties> = {
  teamTabFooterContainer: {
    width: '100%',
    borderRadius: 8,
    paddingTop: 16,
    paddingBottom: 16,
    paddingLeft: 24,
    paddingRight: 24,
    marginTop: 16,
    marginBottom: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: Colors.greyLighter,
  },
  emptyIconContainer: {
    backgroundColor: Colors.PAPER_DIVIDER_CONTAINER,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 32,
    height: 32,
  },
  emptyIconCenter: {
    backgroundColor: Colors.PAPER_DIVIDER_CONTAINER_DARK,
    borderRadius: '50%',
    width: 8,
    height: 8,
  }
}

export default OrganizationTabTeam;